"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HttpService = void 0;
var _version = require("../version.json");
var _app = require("./app");
class HttpService {
  static getAuthorizationToken() {
    try {
      const authorizationToken = typeof window !== 'undefined' && (localStorage.getItem('impersonate_authorization_token') || localStorage.getItem('authorization_token') || sessionStorage.getItem('authorization_token')) || null;
      return authorizationToken;
    } catch {
      console.error('localStorage access is denied');
    }
    return null;
  }
  static authorizationToken = this.getAuthorizationToken();
  static partner = null;
  static request(method, endPoint, route, queryParams, headers, body, {
    setAuthorizationToken,
    contentType,
    responseType,
    expectedStatus,
    partner
  }) {
    const {
      backendUrl,
      defaultApiVersion,
      apiVersions,
      apiKey,
      source
    } = _app.AppService.environment;
    const apiUrl = `${backendUrl}/api`;
    const apiVersion = apiVersions[endPoint] || defaultApiVersion;
    return new Promise((resolve, reject) => {
      const request = new XMLHttpRequest();
      request.open(method, `${apiUrl}/v${apiVersion}${route}?${queryParams.map(({
        key,
        value
      }) => `${key}=${value}`).join('&')}`, true);
      request.responseType = responseType || 'json';
      if (!(body instanceof FormData)) request.setRequestHeader('Content-Type', contentType || 'application/json;charset=UTF-8');
      request.setRequestHeader('Api-key', apiKey);
      if (source) request.setRequestHeader('Source', source);
      request.setRequestHeader('version', _version.version);
      if (typeof window !== 'undefined') request.setRequestHeader('x-requested-with', `${window.location.host}${window.location.pathname}`);
      if (this.authorizationToken) request.setRequestHeader('Authorization', this.authorizationToken);
      if (partner) request.setRequestHeader('partner', partner);else if (this.partner) request.setRequestHeader('partner', this.partner);
      headers.forEach(({
        key,
        value
      }) => request.setRequestHeader(key, value));
      request.onload = () => {
        let authorizationToken;
        let userId;
        if (setAuthorizationToken) {
          const _authorizationToken = request.getResponseHeader('Authorization');
          const _userId = request.getResponseHeader('UserId');
          if (_authorizationToken && _userId) {
            authorizationToken = this.authorizationToken = _authorizationToken;
            userId = parseInt(_userId, 10);
          } else {
            reject({
              code: request.status,
              message: request.statusText
            });
            return;
          }
        }
        const {
          status,
          response
        } = request;
        if (expectedStatus ? status === expectedStatus : status >= 200 && status < 300) {
          resolve(setAuthorizationToken ? {
            authorizationToken,
            userId
          } : response);
        } else {
          reject(expectedStatus ? {
            status,
            message: response
          } : response || new Error(`Error ${status}`));
        }
      };
      request.onerror = () => {
        console.error('[HTTP] Request Error');
        reject(request.response);
      };
      request.send(body);
    });
  }
  static get(endPoint, route, queryParams = [], headers = [], body = null, params = {}) {
    return this.request('GET', endPoint, route, queryParams, headers, body, params);
  }
  static post(endPoint, route, queryParams = [], headers = [], body = null, params = {}) {
    return this.request('POST', endPoint, route, queryParams, headers, body, params);
  }
  static put(endPoint, route, queryParams = [], headers = [], body = null, params = {}) {
    return this.request('PUT', endPoint, route, queryParams, headers, body, params);
  }
  static patch(endPoint, route, queryParams = [], headers = [], body = null, params = {}) {
    return this.request('PATCH', endPoint, route, queryParams, headers, body, params);
  }
  static async delete(endPoint, route, queryParams = [], headers = [], body = null, params = {}) {
    await this.request('DELETE', endPoint, route, queryParams, headers, body, params);
    return true;
  }
}
exports.HttpService = HttpService;